export const operatorReports = {
	searchTasks: { id: 'search-tasks', name: 'Search Tasks', CR: true, operatorReports: true },
	dayOpenClose: { id: 'dayOpenClose', name: 'Day Open Close', CR: true, operatorReports: true },
};
